import { useCount } from "@/utils/count";
const load = async () => {
    await useCount().countSurvey();
};
export default [
    {
        path: "/pms",
        name: "pms__root__",
        redirect: {
            name: "pms-index",
        },
        component: () => import("@/layouts/default.vue"),
        meta: {
            parent: "pms",
            title: "",
        },
        beforeEnter: async (to, from, next) => {
            try {
                await load();
            } catch (err) {
                console.error(err);
            } finally {
                next();
            }
        },
        children: [
            {
                path: "index",
                name: "pms-index",
                component: () => import("@/views/pms/index.vue"),
                meta: {
                    title: "控制面板",
                    icon: "index",
                    affix: true,
                },
            },
        ],
    },
    {
        path: "/pms/customer",
        name: "pms-customer",
        meta: {
            title: "客户管理",
            icon: "mkt-enterprise",
            parent: "pms",
            permission: "manage_customer",
        },
        // hidden: true,
        component: () => import("@/layouts/default.vue"),
        redirect: "/pms/customer/organization",
        children: [
            {
                path: "organization",
                name: "pms-enterprise-organization",
                component: () => import("@/views/omp/enterprise/organization.vue"),
                meta: {
                    title: "企业管理",
                    icon: "mkt-organization",
                },
            },
            {
                path: "dashboard",
                name: "pms-enterprise-dashboard",
                component: () => import("@/views/omp/enterprise/dashboard.vue"),
                meta: {
                    title: "园区管理",
                    icon: "mkt-dashboard",
                },
            },
            {
                path: "user",
                name: "pms-account-user",
                component: () => import("@/views/omp/account/user.vue"),
                meta: {
                    title: "账号管理",
                    icon: "mkt-account-user",
                },
            },
            {
                path: "other",
                name: "pms-account-other",
                component: () => import("@/views/omp/account/other-user.vue"),
                meta: {
                    title: "散户管理",
                    icon: "mkt-account-other",
                },
            },
            {
                path: "address",
                name: "pms-customer-address",
                component: () => import("@/views/fms/customer/address.vue"),
                meta: {
                    title: "地址管理",
                    icon: "mkt-address",
                },
            },
        ],
    },
    {
        path: "/pms/general",
        name: "pms-general",
        meta: {
            title: "产品管理",
            icon: "pms-general",
            parent: "pms",
        },
        component: () => import("@/layouts/default.vue"),
        redirect: "/pms/general/goods_price",
        children: [
            {
                path: "goods_price",
                name: "pms-mall-goods-price",
                component: () => import("@/views/fms/mall/goods_price.vue"),
                meta: {
                    title: "商城产品",
                    icon: "finance-mall-orders",
                    affix: false,
                    permission: "manage_product_price",
                },
            },
            {
                path: "goods_price_detail/:id(\\d+)?",
                name: "pms-mall-goods-price-detail",
                hidden: true,
                component: () => import("@/views/fms/mall/goods_price_detail.vue"),
                meta: {
                    title: "商品详情",
                    affix: false,
                    activeMenu: "/pms/general/goods_price",
                    permission: "manage_product_price",
                },
            },
            {
                path: "sim",
                name: "pms-general-sim",
                component: () => import("@/views/fms/general/sim.vue"),
                meta: {
                    title: "流量套餐",
                    icon: "pms-general-sim",
                    affix: false,
                    permission: "manage_general",
                },
            },
            {
                path: "sim-detail/:order_no",
                name: "pms-general-sim-detail",
                component: () => import("@/views/fms/general/sim-record-detail.vue"),
                hidden: true,
                meta: {
                    title: "流量套餐详情",
                    affix: false,
                    activeMenu: "/pms/general/sim",
                },
            },
            {
                path: "package",
                name: "pms-general-titan-package",
                component: () => import("@/views/fms/general/titan-package.vue"),
                meta: {
                    title: "泰坦套餐",
                    icon: "pms-general-titan-package",
                    affix: false,
                    permission: "manage_general",
                },
            },
            {
                path: "package-detail/:order_no",
                name: "pms-general-package-detail",
                component: () => import("@/views/fms/general/package-detail.vue"),
                hidden: true,
                meta: {
                    title: "开通详情",
                    affix: false,
                    activeMenu: "/pms/general/package",
                },
            },
            {
                path: "expansion",
                name: "pms-general-expansion-system",
                component: () => import("@/views/fms/general/expansion-system.vue"),
                meta: {
                    title: "拓展系统",
                    icon: "pms-general-expansion-system",
                    affix: false,
                    permission: "manage_general",
                },
            },
            {
                path: "product-detail/:order_no",
                name: "pms-general-product-detail",
                component: () => import("@/views/fms/general/product-detail.vue"),
                hidden: true,
                meta: {
                    title: "开通详情",
                    affix: false,
                    activeMenu: "/pms/general/expansion",
                },
            },
        ],
    },
    {
        path: "/pms/dbmanage",
        name: "dev-dbmanage",
        meta: {
            title: "数据管理",
            icon: "pms-manage-data",
            parent: "pms",
            permission: "manage_data",
        },
        component: () => import("@/layouts/default.vue"),
        redirect: "/pms/dbmanage/album",
        children: [
            {
                path: "titan-package",
                name: "dev-titan-package",
                component: () => import("@/views/fms/dbmanage/titan-package.vue"),
                meta: {
                    title: "套餐数据",
                    icon: "pms-titan-package",
                },
            },
            {
                path: "titan-package/:id(\\d+)",
                name: "dev-titan-package-detail",
                hidden: true,
                component: () => import("@/views/fms/dbmanage/titan-package-detail.vue"),
                meta: {
                    title: "套餐详情",
                    affix: false,
                    activeMenu: "/pms/dbmanage/titan-package",
                },
            },
            {
                path: "album",
                name: "dev-dbmanage-album",
                component: () => import("@/views/fms/dbmanage/album.vue"),
                meta: {
                    title: "相册数据",
                    icon: "pms-manage-album",
                },
            },
            {
                path: "aigrow",
                name: "dev-dbmanage-aigrow",
                component: () => import("@/views/omp/aigrow/stat/index.vue"),
                meta: {
                    title: "识别数据",
                    icon: "pms-manage-aigrow",
                },
            },
            {
                path: "device",
                name: "pms-manage-device",
                component: () => import("@/views/fms/dbmanage/device.vue"),
                meta: {
                    title: "设备数据",
                    icon: "pms-manage-device",
                },
            },
        ],
    },
    {
        path: "/pms/support",
        name: "pms-support",
        component: () => import("@/layouts/default.vue"),
        redirect: "/pms/support/feedback",
        meta: {
            title: "支持中心",
            icon: "mkt-consult",
            parent: "pms",
        },
        beforeEnter: async (to, from, next) => {
            await useCount().countSurvey();
            next();
        },
        children: [
            {
                path: "survey",
                name: "pms-support-survey",
                component: () => import("@/views/pms/support/survey.vue"),
                meta: {
                    title: "问卷回访",
                    icon: "pms-support-survey",
                },
            },
            {
                path: "survey-detail/:id",
                name: "pms-support-survey-detail",
                component: () => import("@/views/pms/support/survey-detail.vue"),
                hidden: true,
                meta: {
                    title: "问卷详情",
                    activeMenu: "/pms/support/survey",
                },
            },
            {
                path: "feedback",
                name: "pms-support-feedback",
                component: () => import("@/views/dev/support/feedback.vue"),
                meta: {
                    title: "反馈管理",
                    icon: "pms-support-feedback",
                    permission: "manage_feedback",
                },
            },
            {
                path: "feedback-detail/:id(\\d+)",
                name: "pms-support-feedback-detail",
                component: () => import("@/views/dev/support/feedback-detail.vue"),
                hidden: true,
                meta: {
                    title: "反馈管理",
                    permission: "manage_feedback",
                    activeMenu: "/pms/support/feedback",
                },
            },
            {
                path: "acceptance",
                name: "dev-support-acceptance",
                component: () => import("@/views/fms/acceptance/acceptance.vue"),

                meta: {
                    title: "验收管理",
                    icon: "mkt-acceptance",
                    affix: false,
                    keepAlive: true,
                    permission: "manage_order_sold",
                },
            },
            {
                path: "acceptance/create",
                name: "acceptance-create",
                component: () => import("@/views/fms/acceptance/acceptance-form.vue"),
                props: true,
                meta: {
                    title: "新建验收",
                    activeMenu: "/pms/support/acceptance",
                },
                hidden: true,
            },
        ],
    },
    {
        path: "/pms/account",
        name: "account",
        component: () => import("@/layouts/default.vue"),
        redirect: "/pms/account/list",
        meta: {
            title: "系统账号",
            icon: "pms-account",
            parent: "pms",
            permission: "manage_admin_account",
        },
        children: [
            {
                path: "list",
                name: "account-list",
                component: () => import("@/views/dev/account/list.vue"),
                meta: {
                    title: "账号配置",
                    icon: "pms-account-users",
                    app: "cms",
                },
            },
            {
                path: "role",
                name: "pms-account-role",
                component: () => import("@/views/dev/account/role.vue"),
                meta: {
                    title: "角色配置",
                    icon: "pms-account-role",
                    group: 512,
                },
            },
            {
                path: "permission",
                name: "pms-account-permission",
                component: () => import("@/views/dev/account/permission.vue"),
                meta: {
                    title: "权限配置",
                    icon: "pms-account-permission",
                    group: 512,
                },
            },
        ],
    },

    {
        path: "/pms/log",
        name: "dev-log",
        meta: {
            title: "系统管理",
            icon: "all-system",
            parent: "pms",
            permission: "manage_system_log",
        },
        component: () => import("@/layouts/default.vue"),
        redirect: {
            name: "pms-action-log",
        },
        children: [
            {
                path: "dev-action-log",
                name: "pms-dev-action-log",
                component: () => import("@/views/dev/system/action_log.vue"),
                meta: {
                    title: "操作日志（后台）",
                    icon: "pms-dev-action-log",
                },
            },
            {
                path: "omp-action-log",
                name: "pms-omp-action-log",
                component: () => import("@/views/omp/system/action_log.vue"),
                meta: {
                    title: "操作日志（用户）",
                    icon: "pms-omp-action-log",
                },
            },
            {
                path: "cms-upload-log",
                name: "pms-cms-upload-log",
                component: () => import("@/views/dev/system/upload_log.vue"),
                meta: {
                    title: "上传日志（后台）",
                    icon: "pms-cms-upload-log",
                },
            },
            {
                path: "omp-upload-log",
                name: "pms-omp-upload-log",
                component: () => import("@/views/omp/system/upload_log.vue"),
                meta: {
                    title: "上传日志（用户）",
                    icon: "pms-omp-upload-log",
                },
            },
            {
                path: "sms-log",
                name: "omp-sms-log",
                component: () => import("@/views/omp/system/sms_log.vue"),
                meta: {
                    title: "短信日志",
                    icon: "pms-omp-sms-log",
                },
            },
        ],
    },
];
